import React, {ReactNode} from "react"
import {RouteContext} from "../utils/context";
import {PageHeader} from "antd";
import urlToList from "../utils/urlToList";
import {pathToRegexp} from "path-to-regexp";
import {Link, useHistory} from "react-router-dom";


interface PageHeaderLayoutProps {
    title?: ReactNode,
    children: ReactNode,
    canBack?: boolean
}

function PageHeaderLayout(props: PageHeaderLayoutProps) {

    const {children, canBack = false, title} = props
    const history = useHistory()

    function generateBreadcrumb(routes?: Routes, path?: string) {
        if (!routes || !path) return []
        const paths = urlToList(path)
        return paths.map(it => {
            const regexp = pathToRegexp(it)
            return Object.keys(routes).find(route => regexp.test(route))
        }).filter(it => it).map(it => {
            const route = routes[it!]
            return {
                path: (route.component || route.render) ? it! : "",
                breadcrumbName: route.name || "",
            }
        })
    }

    return (
        <div>
            <RouteContext.Consumer>
                {props => {
                    const route = props?.routes[props?.path]
                    const breadcrumb = generateBreadcrumb(props?.routes, props?.path)
                    breadcrumb.unshift({path: '/', breadcrumbName: "Root"})
                    return (
                        <PageHeader ghost={false}
                                    breadcrumb={{
                                        routes: breadcrumb,
                                        itemRender: (route) => (!route.path ? <span>{route.breadcrumbName}</span> :
                                                <Link to={route.path}>{route.breadcrumbName}</Link>
                                        )
                                    }}
                                    title={title || route?.name}
                                    onBack={canBack ? () => {
                                        history.goBack()
                                    } : undefined}
                        />
                    )
                }}
            </RouteContext.Consumer>
            <div style={{margin: '24px 24px 0'}}>
                {children}
            </div>
        </div>
    )

}

export default PageHeaderLayout
